import { createDataSelectors } from "@app/modules/app.reducers";
import { Role } from "@ea/shared_types/types";

export const roleDataSelectors = createDataSelectors<Role>()("roles");
